import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Spin, Input, Button, Select, Col, message } from 'antd';
// Services
import api from 'services/api';
import i18n from 'services/i18n';
// Components
import LazySelect from 'components/LazySelect';
// Options
import { NUMERIC_SIGN, LANGUAGE_LEVEL, FILTER_TYPE } from 'constants/options';

@i18n('form')
@Form.create()
class LanguageFilter extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
  };

  static defaultProps = {
    loading: false,
  };

  state = {
    languages: [],
  };

  handleLoadLanguages = data => {
    return api
      .getAllLanguages(data)
      .then(res => {
        // Save questions in temp var
        this.setState({ languages: res.data.data });
        return res.data;
      })
      .catch(err => message.error(this.props.translate('all', 'error')));
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const data = {
          criterion: {
            isOnLevel: values.isOnLevel,
            languageId: values.languageId,
            level: values.level,
          },
        };
        // For rendering purposes only, used in CriteriaTable
        // Find selected language
        const language = this.state.languages.find(
          l => l.id === values.languageId,
        );
        data._name = language.name;

        this.props.onSubmit(FILTER_TYPE.LANGUAGE, data);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Spin spinning={this.props.loading}>
        <Form
          className="criteria-form"
          layout="horizontal"
          onSubmit={this.handleSubmit}
        >
          <Form.Item wrapperCol={{ span: 24 }} className="form-full-width">
            {getFieldDecorator('languageId', {
              rules: [
                {
                  required: true,
                  message: this.props.translate('checkboxGroup'),
                },
              ],
            })(<LazySelect loadData={this.handleLoadLanguages} />)}
          </Form.Item>
          <Input.Group>
            <Col span={12}>
              <Form.Item>
                {getFieldDecorator('isOnLevel', {
                  initialValue: 'EQUAL',
                })(
                  <Select placeholder={this.props.translate('chooseOperation')}>
                    {NUMERIC_SIGN.map(item => (
                      <Select.Option key={item.value} value={item.value}>
                        {this.props.translate(item.value)}
                      </Select.Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                {getFieldDecorator('level', {
                  initialValue: 'A1',
                })(
                  <Select placeholder={this.props.translate('chooseLevel')}>
                    {LANGUAGE_LEVEL.map(item => (
                      <Select.Option key={item.key} value={item.value}>
                        {item.title}
                      </Select.Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Input.Group>
          <Button htmlType="submit" icon="plus" className="add-btn">
            {this.props.translate('add')}
          </Button>
        </Form>
      </Spin>
    );
  }
}

export default LanguageFilter;
